var map = {
	"./level-dialog.da.i18n": [
		96044,
		45013
	],
	"./level-dialog.de.i18n": [
		6568,
		66193
	],
	"./level-dialog.en.i18n": [
		63904,
		40581
	],
	"./level-dialog.es.i18n": [
		49067,
		33258
	],
	"./level-dialog.fi.i18n": [
		96054,
		59767
	],
	"./level-dialog.fr.i18n": [
		27027,
		29550
	],
	"./level-dialog.hi.i18n": [
		83168,
		41945
	],
	"./level-dialog.id.i18n": [
		21062,
		45107
	],
	"./level-dialog.it.i18n": [
		57942,
		98563
	],
	"./level-dialog.ja.i18n": [
		89434,
		38987
	],
	"./level-dialog.ko.i18n": [
		56625,
		35040
	],
	"./level-dialog.nl.i18n": [
		79257,
		69668
	],
	"./level-dialog.no.i18n": [
		29760,
		95785
	],
	"./level-dialog.pl.i18n": [
		46219,
		46550
	],
	"./level-dialog.pt.i18n": [
		70659,
		14126
	],
	"./level-dialog.ru.i18n": [
		44726,
		14871
	],
	"./level-dialog.sv.i18n": [
		96018,
		14823
	],
	"./level-dialog.zh.i18n": [
		44337,
		53564
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65366;
module.exports = webpackAsyncContext;